import axios from 'axios'
import {useQuery} from 'react-query'
import {ParamsModel} from 'src/app/modules/common/Model'
import {API_URL} from 'src/cms/constants/EndPoint'

const PROVINCE_API = `${API_URL}/province`

export interface IProvince {
  code: number
  id: string
  title: string
  titleNp: string
}

const fetchProvinceOptions = async () => {
  try {
    const {data} = await axios.get(PROVINCE_API)
    return data?.data?.province?.map((item: IProvince) => ({
      label: item?.title,
      value: item?.id,
      code: item?.code,
    }))
  } catch (error: any) {
    throw new Error(`Error fetching provinces: ${error.message}`)
  }
}

const useGetProvinceOptions = () => {
  return useQuery(['getProvinceOptions'], () => fetchProvinceOptions())
}

export default useGetProvinceOptions
